export const GITHUB_INTEGRATION = {
  TITLE: 'Conecta tu organización de GitHub',
  STEP1: {
    DESCRIPTION: 'Ingresa el login de tu organización de GitHub para comenzar el proceso de conexión.',
    INPUT_LABEL: 'Login de organización de GitHub',
    INPUT_HELP_LINK: '¿Cómo accedo a la organización?',
    INPUT_ERROR: 'Por favor ingresa el login de tu organización',
    PERMISSIONS_DISCLAIMER: 'La cuenta debe tener privilegios de propietario o administrador de la organización.',
  },
  STEP2: {
    DESCRIPTION: 'Verifica la organización. Serás redirigido a GitHub para instalar la aplicación de Qalea.',
    ADDITIONAL_INFO: 'La aplicación debe instalarse en esta organización. Consulta la',
    ADDITIONAL_INFO_LINK: 'guía de integración',
    ADDITIONAL_INFO_SUFFIX: 'para más detalles.',
  },
  FOOTER: {
    CANCEL: 'Cancelar',
    CONTINUE: 'Continuar',
    BACK: 'Atrás',
    OPEN_EXTERNAL: 'Abrir GitHub',
  },
  STEP_PROGRESS: {
    STEP_1: 'Paso 1: Detalles de la Organización',
    STEP_2: 'Paso 2: Revisión e Instalación',
  },
}
